console.log('site-child.js');

//vendors aos
//import AOS from 'aos';
//import 'aos/dist/aos.css';
//import anionscroll from "./modules/aos.js";

//vendors scrollreveal
import ScrollReveal from 'scrollreveal';

//vendors slick-carousel
import slick from 'slick-carousel';

import carouselSlider from './modules/slick-carousel.js';
var carousel = new carouselSlider();

import carouselSliderCamere from './modules/slick-camere.js';
var carouselCamere = new carouselSliderCamere();

import carouselSliderOfferte from './modules/slick-offerte.js';
var carouselOfferte = new carouselSliderOfferte();

// css
import '../scss/style.scss';

//page builder framework theme js
//import './modules/page-builder-framework.js';
//cookie consent js
import './modules/cookieconsent.min.js';

(function ($) {
  $(document).ready(function () {
    // estensione apertura menu fullscreen
    function menuTogglePw() {
      if ($('.wpbf-menu-full-screen').hasClass('active')) {
        $('body').removeClass('noscroll');
      } else {
        $('body').addClass('noscroll');
      }
    }
    $('.wpbf-menu-toggle').click(function () {
      menuTogglePw();
    });

    //aggiungo attributo per aos e inizializzo il js - FUNZIONE DI TEST DISATTIVATA
    //$('section .elementor-widget').attr('data-aos', 'fade-up');
    /*
		AOS.init({
			offset: 120,
			duration: 400,
			mirror: true,
			delay: 250,
		});
		*/

    //inizializzo scrollreveal - FUNZIONE DI TEST DISATTIVATA
    /*
		var slideUp = {
			scale: 1,
			distance: '80px',
			origin: 'bottom',
			opacity: 0,
			delay: 100,
			reset: true
		};
		var slideDown = {
			distance: '40px',
			origin: 'top',
			opacity: 0,
			easing: 'ease-in',
			reset: true
		};
		*/
    //ScrollReveal().reveal('section .elementor-widget', slideUp);
    //ScrollReveal().reveal('section .elementor-widget', slideDown);

    // funzione mouse scroll - FUNZIONE DI TEST DISATTIVATA
    /*
		var position = $(window).scrollTop(); 
		$(window).scroll(function() {
				var scroll = $(window).scrollTop();
				if(scroll > position) {
						console.log('scrollDown');
						//ScrollReveal().reveal('section .elementor-widget', slideUp);
						
				} else {
						console.log('scrollUp');
						//ScrollReveal().reveal('section .elementor-widget', slideDown);
				}
				position = scroll;
		});
		*/

    // ScrollReveal con callback
    var beforeRevealCallback = function (el) {
      var id = el.getAttribute('data-sr-id');
      var containerId = ScrollReveal().store.elements[id].containerId;
      var container = ScrollReveal().store.containers[containerId];

      if (container.direction && container.direction.y > 0) {
        el.classList.add('animateFromBottom');
      } else {
        el.classList.add('animateFromTop');
      }
    };
    var beforeResetCallback = function (el) {
      el.classList.remove('animateFromBottom');
      el.classList.remove('animateFromTop');
    };

    var noEffect = {
      delay: 0,
      distance: '0',
      duration: 0,
      easing: 'linear',
      opacity: null,
      origin: 'bottom',
      rotate: { x: 0, y: 0, z: 0 },
      scale: 1,
      //	container: this.defaults.container,
      //	desktop: this.defaults.desktop,
      mobile: false,
      reset: true,
      useDelay: 'always',
      //	viewFactor: this.defaults.viewFactor,
      //	viewOffset: this.defaults.viewOffset,

      afterReset: function (el) {},
      afterReveal: function (el) {},
      beforeReset: beforeResetCallback, // fill me in
      beforeReveal: beforeRevealCallback, // fill me in
    };
    ScrollReveal().reveal('section .elementor-widget', noEffect);

    //aggiungo pulsante alle immagini lightbox
    $('a[data-elementor-open-lightbox=yes]').append(
      '<div class="lightboxover"></div>'
    );

    //uso come background per fullscreen i dettagli
    var isMobile = false;
    if (
      /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(
        navigator.userAgent
      ) ||
      /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
        navigator.userAgent.substr(0, 4)
      )
    ) {
      isMobile = true;
    }
    if (isMobile == false) {
      var widthscreen = $(document).width();
      $('.wpbf-menu-full-screen').append('<div class="background"></div>');
      var bgImgArray = [
          '/wp-content/uploads/dettagli8.webp',
          '/wp-content/uploads/dettagli3.webp',
          '/wp-content/uploads/dettagli5.webp',
          '/wp-content/uploads/dettagli4.webp',
        ],
        selectBG = bgImgArray[Math.floor(Math.random() * bgImgArray.length)];
      $('.background').css('background-image', 'url(' + selectBG + ')');
      console.log(widthscreen);
    }

    window.cookieconsent.initialise({
      palette: {
        popup: {
          background: '#000000',
          text: '#ffffff',
        },
        button: {
          background: '#ac8500',
          text: '#ffffff',
        },
      },
      theme: 'edgeless',
      content: {
        message:
          "Utilizziamo cookie tecnici e di non profilazione per assicurarti una migliore esperienza sul sito. Se prosegui nella navigazione acconsenti all'utilizzo dei Cookie. Per maggiori informazioni sui cookie e sulla loro disabilitazione consulta la:  ",
        dismiss: 'ok',
        link: 'cookie policy',
        href:
          'https://dmc12.pensareweb.it/cookie_policy/hotelmontecarloriccione-com/',
      },
    });
  });
})(jQuery);
